// @flow
import { colors } from 'bench-style-constants';
import React from 'react';
import styled from 'styled-components';

const DetailItemLayout = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
`;

const Label = styled.label`
  color: ${colors.ash};
  flex: 0 0 150px;
  font-size: 12px;
  line-height: 16px;
  margin: 0;
`;

const Value = styled.p`
  color: ${colors.cloud};
  font-size: 12px;
  line-height: 16px;
  margin: 0;
`;

type DetailItemProps = {
  label: string,
  value: string,
};

const DetailItem = ({ label, value }: DetailItemProps) => (
  <DetailItemLayout>
    <Label>{label}:</Label>
    <Value>{value}</Value>
  </DetailItemLayout>
);

export default DetailItem;
